module.exports = __webpack_public_path__ + "static/wle-gradient-b32df40f8526f783335b89393a1202be.jpg";